import type { QuestionStatus } from '@exam-management/graphql';
import { Flex, SectionTitle } from '@shared/components';

import { EDITABLE_QUESTION_DETAILS_STATUSES } from '../../constants';
import { InformationFormSection } from '../information-form-section';
import { InformationView } from '../information-view';

export interface InformationSectionType {
  readonly: boolean;
  questionStatus: QuestionStatus;
  onClick?: () => void;
}

export default function InformationSection(props: Readonly<InformationSectionType>) {
  const { readonly: isReadonly = false, questionStatus, onClick } = props;
  const isEditable = EDITABLE_QUESTION_DETAILS_STATUSES.includes(questionStatus) && !isReadonly;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <SectionTitle title='Information' />
      {isEditable ? (
        <InformationFormSection questionStatus={questionStatus} onClick={onClick} />
      ) : (
        <InformationView />
      )}
    </Flex>
  );
}
